import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { BUILDER_BLOCK_DELETED, BUILDER_BLOCK_COPIED, BUILDER_BLOCK_UPGRATED, BUILDER_FLOW_SEARCHED, BUILDER_FLOW_VARIABLES_DICTIONARY_OPENED, BUILDER_FLOW_PUBLISHED, BUILDER_PUBLISH_SUCCESS, BUILDER_PUBLISH_ERROR, BUILDER_CONFIGURATION_LAST_VERSION_RESTORED, BUILDER_CONFIGURATION_VERSION_RESTORED, BUILDER_CONFIGURATION_VERSION_UPLOADED, BUILDER_CONFIGURATION_VERSION_DOWNLOADED, BUILDER_CONFIGURATION_VARIABLES_AUTO_TRACKING_ENABLED, BUILDER_CONFIGURATION_VARIABLES_AUTO_TRACKING_DISABLED, BUILDER_CONFIGURATION_VARIABLES_AI_CONFIABILITY_DEFINED, BUILDER_CONFIGURATION_VARIABLES_ADDED, BUILDER_SECRET_CONFIGURATION_VARIABLES_ADDED, BUILDER_CONFIGURATION_VARIABLES_REMOVED, BUILDER_SECRET_CONFIGURATION_VARIABLES_REMOVED, BUILDER_ACTION, BUILDER_BLOCK_ACTION_LIBRARY_CALLED_ACTION, BUILDER_BLOCK_ACTION_LIBRARY_CALLED_SCRIPT, BUILDER_BLOCK_ACTION_ADDED, BUILDER_BLOCK_GLOBAL_ACTION_ADDED, BUILDER_BLOCK_ACTION_DELETED, BUILDER_BLOCK_GLOBAL_ACTION_DELETED, BUILDER_BLOCK_ACTION_POSITION_CHANGED, BUILDER_BLOCK_CONTENT_ADDED, BUILDER_BLOCK_CONTENT_DELETED, BUILDER_BLOCK_CONTENT_POSITION_CHANGED, BUILDER_BLOCK_CONTENT_WAIT_INPUT_ENABLED, BUILDER_BLOCK_CONTENT_WAIT_INPUT_DISABLED, BUILDER_BLOCK_CONTENT_WAIT_INPUT_CHANGED, BUILDER_BLOCK_OUTPUT_CONDITION_ADDED, BUILDER_BLOCK_OUTPUT_CONDITION_DELETED, BUILDER_BLOCK_OUTPUT_CONDITION_EDITED, BUILDER_BLOCK_OUTPUT_CONDITION_IF_EDITED, BUILDER_BLOCK_OUTPUT_CONDITION_CONDITION_EDITED, BUILDER_BLOCK_OUTPUT_DEFAULT_CONDITION_EDITED, BUILDER_BLOCK_DESK_OUTPUT_DEFAULT_CONDITION_EDITED, BUILDER_BLOCK_OUTPUT_CONDITIONS_POSITION_CHANGED, BUILDER_BLOCK_TAGGED, BUILDER_BLOCK_NAME_EDITED, BUILDER_WRITE_RELEASED, BUILDER_WRITE_REQUEST, BUILDER_FLOW_LOADED, BUILDER_FLOW_BLOCK_MULTI, BUILDER_FLOW_MULTIPLE_BLOCKS_UNDO, BUILDER_FLOW_MULTIPLE_BLOCKS_REDO, BUILDER_FLOW_COMMANDS, BUILDER_BLOCK_UNDO, BUILDER_BLOCK_REDO, BUILDER_BLOCK_ACTION_UNDO, BUILDER_BLOCK_ACTION_REDO, BUILDER_BLOCK_CONTENT_UNDO, BUILDER_BLOCK_CONTENT_REDO, BUILDER_BLOCK_CRUD_UNDO, BUILDER_BLOCK_CRUD_REDO, BUILDER_BLOCK_OUTPUT_REDO, BUILDER_BLOCK_OUTPUT_UNDO, BUILDER_BLOCK_CONTENT_USERS_ENTRY_OPENED, BUILDER_BLOCK_RIGHT_CLICKED, BUILDER_BLOCK_CONTEXT_MENU_COPIED, BUILDER_BLOCK_ID_COPIED, BUILDER_WRITE_LOCK_GRANTED, BUILDER_WRITE_LOCK_DENIED, BUILDER_BLOCK_AI_ACTIVATED, BUILDER_BLOCK_CONTENT_INPUT_INACTIVITY_CHANGED, BUILDER_BLOCK_CONTENT_INPUT_INACTIVITY_INFO_CLICKED, BUILDER_BLOCK_OUTPUT_CONDITION__INPUT_NOT_EXIST_ADDED, BUILDER_BLOCK_CONFIGURATION_REDO, BUILDER_BLOCK_CONFIGURATION_UNDO, BUILDER_BLOCK_INPUT_UNDO, BUILDER_BLOCK_INPUT_REDO, BUILDER_BLOCK_ACTION_EDITED, BUILDER_BLOCK_CONTENT_CHANGED, BUILDER_BLOCK_GLOBAL_ACTION_EDITED, CONTENT_RESOURCE_ADDED, LOG_SEARCH, LOG_MORE_DATA, CONTENT_RESOURCE_ADD_NEW, CONTENT_RESOURCE_EDITED, CONTENT_RESOURCE_DELETED, BUILDER_SUBFLOW_CREATE_MODAL_OPENED, BUILDER_BLOCK_SUBFLOW_WHAT_IS_SUBFLOW_OPENED, BUILDER_BLOCK_SUBFLOW_CONFIGURATION_OPENED, BUILDER_BLOCK_SUBFLOW_OPENED, BUILDER_BLOCK_SUBFLOW_ENDBLOCK_CLICKED, BUILDER_SUBFLOW_LOADED, BUILDER_BLOCK_SUBFLOW_PUBLISHED, BUILDER_BLOCK_SUBFLOW_DELETED, BUILDER_SUBFLOW_CONFIGURATION_VERSION_UPLOADED, BUILDER_SUBFLOW_CONFIGURATION_VERSION_DOWNLOADED, BUILDER_BLOCK_SUBFLOW_MODEL_SELECTED, BUILDER_CONFIGURATION_LAST_VERSION_OPENED, BUILDER_BLOCK_OUTPUT_CONDITION_VARIABLE_ADDED, BUILDER_FULLSCREEN, BUILDER_PASTE_BLOCKS, BUILDER_BLOCK_AGENT_VERIFICATION_ADDED, BUILDER_BLOCK_AGENT_VERIFICATION_EDITED, BUILDER_BLOCK_AGENT_VERIFICATION_DELETED, BUILDER_BLOCK_OUT_OF_ATTENDANCE_HOUR_ADDED, BUILDER_BLOCK_OUT_OF_ATTENDANCE_HOUR_EDITED, BUILDER_BLOCK_OUT_OF_ATTENDANCE_HOUR_DELETED, BUILDER_SMART_SALES_PLUGIN_INSTALL_BUTTON_CLICK, BUILDER_BUTTON_ICON_ROBOT_AI, BUILDER_BUTTON_ICON_LIKE_AI, BUILDER_BUTTON_ICON_DESLIKE_AI, BUILDER_LINK_HELP_CENTER_AI, BUILDER_BUTTON_ICON_CREATE_BLOCKS_AI, BUILDER_BANNER_ERROR_AI, BUILDER_SAVED_ACTION_VERSION, BUILDER_CONFIGURATION_LAST_VERSION_NAME, BUILDER_CONFIGURATION_LAST_VERSION_DOWNLOAD, BUILDER_SATISFACTION_SURVEY_FILTERED, BUILDER_SATISFACTION_SURVEY_CREATED_FROM_TEMPLATE, BUILDER_ACTION_SELECT_CHECKBOX, BUILDER_ACTION_SELECT_ALL_CHECKBOXES, BUILDER_ACTION_SELECT_MORE_OPTIONS, BUILDER_MOREOPTIONS_MAIN, BUILDER_PASTE_ACTION, BUILDER_PASTE_ALL_ACTIONS_SELECTED, BUILDER_DELETE_ALL_ACTIONS_SELECTED, BUILDER_COPY_ALL_ACTIONS_SELECTED, BUILDER_HELPCENTER_URL_CLICKED, BUILDER_BLOCK_ACTION_OPEN_LIBRARY, BUILDER_BLOCK_ACTION_LIBRARY_CREATE_FUNCTION, BUILDER_BLOCK_ACTION_LIBRARY_FUNCTION_CREATED, BUILDER_BLOCK_ACTION_LIBRARY_EXPAND_CONTENT, BUILDER_BLOCK_ACTION_LIBRARY_SEARCH, BUILDER_BLOCK_ACTION_LIBRARY_MORE_OPTIONS, BUILDER_BLOCK_ACTION_LIBRARY_DELETE_FUNCTION, BUILDER_BLOCK_ACTION_LIBRARY_EDIT_FUNCTION, BUILDER_BLOCK_ACTION_FUNCTIONS_DELETE_MODAL_IMPACTED, BUILDER_BLOCK_ACTION_FUNCTIONS_DELETE_MODAL, BUILDER_BLOCK_ACTION_FUNCTIONS_EDITED_MODAL_IMPACTED, BUILDER_BLOCK_ACTION_FUNCTIONS_EDITED_MODAL, BUILDER_BLOCK_ACTION_FUNCTIONS_MODAL_REDIRECT_TO_BOT, } from '../BuilderSegmentEvents';
export class BuilderSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    page() {
        this.SegmentService.page({
            name: 'Builder',
            path: window.location.hash,
        });
    }
    trackBlockDeleted(payload, success) {
        const event = this.application.isSubflow ? BUILDER_BLOCK_SUBFLOW_DELETED : BUILDER_BLOCK_DELETED;
        this.trackEvent(event, payload, success);
    }
    trackBlockUpgrated(payload, success) {
        this.trackEvent(BUILDER_BLOCK_UPGRATED, payload, success);
    }
    trackBlockCopied(payload, success) {
        this.trackEvent(BUILDER_BLOCK_COPIED, payload, success);
    }
    trackBlockContextMenuCopied(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTEXT_MENU_COPIED, payload, success);
    }
    trackBlockIdCopied(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ID_COPIED, payload, success);
    }
    trackBuilderBlockRightClicked(payload, success) {
        this.trackEvent(BUILDER_BLOCK_RIGHT_CLICKED, payload, success);
    }
    trackFlowSearched(payload, success) {
        this.trackEvent(BUILDER_FLOW_SEARCHED, payload, success);
    }
    trackFlowCommands(application, payload, success) {
        this.trackApplicationEvent(BUILDER_FLOW_COMMANDS, application, payload, success);
    }
    trackFlowVariablesDictionaryOpened(payload, success) {
        this.trackEvent(BUILDER_FLOW_VARIABLES_DICTIONARY_OPENED, payload, success);
    }
    trackFlowPublished(payload, success) {
        this.trackEvent(BUILDER_FLOW_PUBLISHED, payload, success);
    }
    trackPublishSuccess(payload, success) {
        this.trackEvent(BUILDER_PUBLISH_SUCCESS, payload, success);
    }
    trackPublishError(payload, success) {
        this.trackEvent(BUILDER_PUBLISH_ERROR, payload, success);
    }
    trackConfigurationLastVersionRestored(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_LAST_VERSION_RESTORED, payload, success);
    }
    trackConfigurationLastVersionOpened() {
        this.trackEvent(BUILDER_CONFIGURATION_LAST_VERSION_OPENED, undefined, true);
    }
    trackConfigurationLastVersionName(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_LAST_VERSION_NAME, payload, success);
    }
    trackConfigurationLastVersionDownload(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_LAST_VERSION_DOWNLOAD, payload, success);
    }
    trackConfigurationVersionRestored(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VERSION_RESTORED, payload, success);
    }
    trackConfigurationVersionUploaded(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VERSION_UPLOADED, payload, success);
    }
    trackConfigurationVersionDownloaded(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VERSION_DOWNLOADED, payload, success);
    }
    trackConfigurationVariablesAutoTrackingEnabled(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VARIABLES_AUTO_TRACKING_ENABLED, payload, success);
    }
    trackConfigurationVariablesAutoTrackingDisabled(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VARIABLES_AUTO_TRACKING_DISABLED, payload, success);
    }
    trackConfigurationVariablesAiConfiabilityDefined(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VARIABLES_AI_CONFIABILITY_DEFINED, payload, success);
    }
    trackConfigurationVariablesAdded(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VARIABLES_ADDED, payload, success);
    }
    trackSecretConfigurationVariablesAdded(payload, success) {
        this.trackEvent(BUILDER_SECRET_CONFIGURATION_VARIABLES_ADDED, payload, success);
    }
    trackConfigurationVariablesRemoved(payload, success) {
        this.trackEvent(BUILDER_CONFIGURATION_VARIABLES_REMOVED, payload, success);
    }
    trackSecretConfigurationVariablesRemoved(payload, success) {
        this.trackEvent(BUILDER_SECRET_CONFIGURATION_VARIABLES_REMOVED, payload, success);
    }
    trackingGeneralConfigurationVariables(nameOfTracking, payload, success) {
        this.trackEvent(nameOfTracking, payload, success);
    }
    trackAction(payload, success) {
        this.trackEvent(BUILDER_ACTION, payload, success);
    }
    trackBlockActionAdded(payload, success, isGlobalAction) {
        this.trackEvent(isGlobalAction ? BUILDER_BLOCK_GLOBAL_ACTION_ADDED : BUILDER_BLOCK_ACTION_ADDED, payload, success);
    }
    trackBlockActionDeleted(payload, success, isGlobalAction) {
        this.trackEvent(isGlobalAction ? BUILDER_BLOCK_GLOBAL_ACTION_DELETED : BUILDER_BLOCK_ACTION_DELETED, payload, success);
    }
    trackBlockActionEdited(payload, success, isGlobalAction) {
        this.trackEvent(isGlobalAction ? BUILDER_BLOCK_GLOBAL_ACTION_EDITED : BUILDER_BLOCK_ACTION_EDITED, payload, success);
    }
    trackBlockActionPositionChanged(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_POSITION_CHANGED, payload, success);
    }
    trackBlockActionOpenLibrary(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_OPEN_LIBRARY, payload, success);
    }
    trackBlockActionLibraryDeleteFunction(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_DELETE_FUNCTION, payload, success);
    }
    trackBlockActionLibraryEditFunction(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_EDIT_FUNCTION, payload, success);
    }
    trackBlockActionLibraryCalledAction(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_CALLED_ACTION, payload, success);
    }
    trackBlockActionLibraryCalledScript(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_CALLED_SCRIPT, payload, success);
    }
    trackBlockActionLibraryCreateFunction(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_CREATE_FUNCTION, payload, success);
    }
    trackBlockActionLibraryFunctionCreated(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_FUNCTION_CREATED, payload, success);
    }
    trackBlockActionLibraryExpandContent(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_EXPAND_CONTENT, payload, success);
    }
    trackBlockActionLibrarySearch(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_SEARCH, payload, success);
    }
    trackBlockActionLibraryMoreOptions(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_LIBRARY_MORE_OPTIONS, payload, success);
    }
    trackBlockActionFunctionsDeleteModalImpacted(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_FUNCTIONS_DELETE_MODAL_IMPACTED, payload, success);
    }
    trackBlockActionFunctionsDeleteModal(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_FUNCTIONS_DELETE_MODAL, payload, success);
    }
    trackBlockActionFunctionsEditedModalImpacted(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_FUNCTIONS_EDITED_MODAL_IMPACTED, payload, success);
    }
    trackBlockActionFunctionsEditedModal(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_FUNCTIONS_EDITED_MODAL, payload, success);
    }
    trackBlockActionFunctionsModalRedirectToBot(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_FUNCTIONS_MODAL_REDIRECT_TO_BOT, payload, success);
    }
    trackBlockContentAdded(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_ADDED, payload, success);
    }
    trackSubflowConfigurationOpened(payload, success) {
        this.trackEvent(BUILDER_BLOCK_SUBFLOW_CONFIGURATION_OPENED, payload, success);
    }
    trackSubflowOpened(payload, success) {
        this.trackEvent(BUILDER_BLOCK_SUBFLOW_OPENED, payload, success);
    }
    trackBlockContentChanged(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_CHANGED, payload, success);
    }
    trackBlockContentDeleted(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_DELETED, payload, success);
    }
    trackBlockContentPositionChanged(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_POSITION_CHANGED, payload, success);
    }
    trackBlockContentWaitInputEnabled(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_WAIT_INPUT_ENABLED, payload, success);
    }
    trackBlockContentWaitInputDisabled(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_WAIT_INPUT_DISABLED, payload, success);
    }
    trackBlockContentWaitInputChanged(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_WAIT_INPUT_CHANGED, payload, success);
    }
    trackBlockOutputConditionAdded(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITION_ADDED, payload, success);
    }
    trackBlockOutputConditionDeleted(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITION_DELETED, payload, success);
    }
    trackBlockOutputConditionEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITION_EDITED, payload, success);
    }
    trackBlockOutputConditionIfEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITION_IF_EDITED, payload, success);
    }
    trackBlockOutputConditionConditionEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITION_CONDITION_EDITED, payload, success);
    }
    trackBlockOutputConditionVariableAdded(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITION_VARIABLE_ADDED, payload, success);
    }
    trackBlockOutputDefaultConditionEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_DEFAULT_CONDITION_EDITED, payload, success);
    }
    trackBlockDeskOutputDefaultConditionEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_DESK_OUTPUT_DEFAULT_CONDITION_EDITED, payload, success);
    }
    trackBlockOutputConditionsPositionChanged(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITIONS_POSITION_CHANGED, payload, success);
    }
    trackBlockTagged(payload, success) {
        this.trackEvent(BUILDER_BLOCK_TAGGED, payload, success);
    }
    trackBlockNameEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_NAME_EDITED, payload, success);
    }
    trackWriteReleased(payload, success) {
        this.trackEvent(BUILDER_WRITE_RELEASED, payload, success);
    }
    trackWriteRequest(payload, success) {
        this.trackEvent(BUILDER_WRITE_REQUEST, payload, success);
    }
    trackFlowLoaded(payload, success) {
        this.trackEvent(BUILDER_FLOW_LOADED, payload, success);
    }
    trackBlockUndo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_UNDO, payload, success);
    }
    trackBlockMulti(payload, success) {
        this.trackEvent(BUILDER_FLOW_BLOCK_MULTI, payload, success);
    }
    trackMultiblocksPositionUndo(payload, success) {
        this.trackEvent(BUILDER_FLOW_MULTIPLE_BLOCKS_UNDO, payload, success);
    }
    trackMultiblocksPositionRedo(payload, success) {
        this.trackEvent(BUILDER_FLOW_MULTIPLE_BLOCKS_REDO, payload, success);
    }
    trackBlockRedo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_REDO, payload, success);
    }
    trackBlockContentUndo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_UNDO, payload, success);
    }
    trackBlockContentRedo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_REDO, payload, success);
    }
    trackBlockCrudUndo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CRUD_UNDO, payload, success);
    }
    trackBlockCrudRedo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CRUD_REDO, payload, success);
    }
    trackBlockActionUndo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_UNDO, payload, success);
    }
    trackBlockOutputRedo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_REDO, payload, success);
    }
    trackBlockOutputUndo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_UNDO, payload, success);
    }
    trackBlockActionRedo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_ACTION_REDO, payload, success);
    }
    trackBlockConfigurationRedo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONFIGURATION_REDO, payload, success);
    }
    trackBlockConfigurationUndo(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONFIGURATION_UNDO, payload, success);
    }
    trackWriteLockGranted(payload, success) {
        this.trackEvent(BUILDER_WRITE_LOCK_GRANTED, payload, success);
    }
    trackWriteLockDenied(payload, success) {
        this.trackEvent(BUILDER_WRITE_LOCK_DENIED, payload, success);
    }
    trackBuilderBlockContentInputInactivityChange(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_INPUT_INACTIVITY_CHANGED, payload, success);
    }
    trackBuilderBlockContentInputInactivityInfoClicked(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_INPUT_INACTIVITY_INFO_CLICKED, payload, success);
    }
    trackBuilderBlockContentUsersEntryOpened(payload, success) {
        this.trackEvent(BUILDER_BLOCK_CONTENT_USERS_ENTRY_OPENED, payload, success);
    }
    trackBuilderBlockAiActivated(payload, success) {
        this.trackEvent(BUILDER_BLOCK_AI_ACTIVATED, payload, success);
    }
    trackBuilderBlockOutputConditionInputNotExistsAdded(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUTPUT_CONDITION__INPUT_NOT_EXIST_ADDED, payload, success);
    }
    trackInputControllerUndoAction(payload, success) {
        this.trackEvent(BUILDER_BLOCK_INPUT_UNDO, payload, success);
    }
    trackInputControllerRedoAction(payload, success) {
        this.trackEvent(BUILDER_BLOCK_INPUT_REDO, payload, success);
    }
    trackVariablesAutoTracking(event, payload, success) {
        this.trackEvent(event, payload, success);
    }
    trackLogSearch(payload, success) {
        this.trackEvent(LOG_SEARCH, payload, success);
    }
    trackLogMoreData(payload, success) {
        this.trackEvent(LOG_MORE_DATA, payload, success);
    }
    trackAddNewResource(payload, success, application) {
        this.trackEvent(CONTENT_RESOURCE_ADD_NEW, payload, success, application);
    }
    trackAddResource(payload, success, application) {
        this.trackEvent(CONTENT_RESOURCE_ADDED, payload, success, application);
    }
    trackEditResource(payload, success, application) {
        this.trackEvent(CONTENT_RESOURCE_EDITED, payload, success, application);
    }
    trackDeleteResource(payload, success, application) {
        this.trackEvent(CONTENT_RESOURCE_DELETED, payload, success, application);
    }
    trackSubFlowLoaded(payload, success) {
        this.trackEvent(BUILDER_SUBFLOW_LOADED, payload, success);
    }
    trackSubflowCreateModalOpened(payload, application) {
        this.trackEvent(BUILDER_SUBFLOW_CREATE_MODAL_OPENED, payload, true, application);
    }
    trackWhatIsSubflowOpened(payload, application) {
        this.trackEvent(BUILDER_BLOCK_SUBFLOW_WHAT_IS_SUBFLOW_OPENED, { ...payload, article: 'What is subflow' }, true, application);
    }
    trackSubflowEndBlockClicked(application) {
        this.trackEvent(BUILDER_BLOCK_SUBFLOW_ENDBLOCK_CLICKED, undefined, true, application);
    }
    trackSubflowPublished(payload, success, application) {
        this.trackEvent(BUILDER_BLOCK_SUBFLOW_PUBLISHED, payload, success, application);
    }
    trackSubflowConfigurationVersionUploaded(payload, success) {
        this.trackEvent(BUILDER_SUBFLOW_CONFIGURATION_VERSION_UPLOADED, payload, success);
    }
    trackSubflowConfigurationVersionDownloaded(payload, success) {
        this.trackEvent(BUILDER_SUBFLOW_CONFIGURATION_VERSION_DOWNLOADED, payload, success);
    }
    trackSubflowModelSelected(copySubflow, application) {
        this.trackEvent(BUILDER_BLOCK_SUBFLOW_MODEL_SELECTED, { Model: copySubflow ? 'copy' : 'new' }, true, application);
    }
    trackBuilderFullscreen(payload) {
        this.trackEvent(BUILDER_FULLSCREEN, payload, true);
    }
    trackBuilderPasteBlocks(payload) {
        this.trackEvent(BUILDER_PASTE_BLOCKS, payload, true);
    }
    trackSmartSalesPluginInstallButtonClick() {
        this.trackEvent(BUILDER_SMART_SALES_PLUGIN_INSTALL_BUTTON_CLICK);
    }
    trackBlockAgentVerificationAdded(payload, success) {
        this.trackEvent(BUILDER_BLOCK_AGENT_VERIFICATION_ADDED, payload, success);
    }
    trackBlockAgentVerificationEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_AGENT_VERIFICATION_EDITED, payload, success);
    }
    trackBlockAgentVerificationDeleted(payload, success) {
        this.trackEvent(BUILDER_BLOCK_AGENT_VERIFICATION_DELETED, payload, success);
    }
    trackBlockOutOfAttendanceHourVerificationAdded(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUT_OF_ATTENDANCE_HOUR_ADDED, payload, success);
    }
    trackBlockOutOfAttendanceHourVerificationEdited(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUT_OF_ATTENDANCE_HOUR_EDITED, payload, success);
    }
    trackBlockOutOfAttendanceHourVerificationDeleted(payload, success) {
        this.trackEvent(BUILDER_BLOCK_OUT_OF_ATTENDANCE_HOUR_DELETED, payload, success);
    }
    trackButtonIconRobotAi(payload, success) {
        this.trackEvent(BUILDER_BUTTON_ICON_ROBOT_AI, payload, success);
    }
    trackButtonIconCreateBlocksAi(payload, success) {
        this.trackEvent(BUILDER_BUTTON_ICON_CREATE_BLOCKS_AI, payload, success);
    }
    trackLinkHelpCenterAi(payload, success) {
        this.trackEvent(BUILDER_LINK_HELP_CENTER_AI, payload, success);
    }
    trackBannerErrorAi(payload, success) {
        this.trackEvent(BUILDER_BANNER_ERROR_AI, payload, success);
    }
    trackButtonIconLiketAi(payload, success) {
        this.trackEvent(BUILDER_BUTTON_ICON_LIKE_AI, payload, success);
    }
    trackButtonIconDeslikeAi(payload, success) {
        this.trackEvent(BUILDER_BUTTON_ICON_DESLIKE_AI, payload, success);
    }
    trackBuilderSavedActionVersion(payload, success) {
        this.trackEvent(BUILDER_SAVED_ACTION_VERSION, payload, success);
    }
    trackSatisfactionSurveyCreatedFromTemplate(payload, success) {
        this.trackEvent(BUILDER_SATISFACTION_SURVEY_CREATED_FROM_TEMPLATE, payload, success);
    }
    trackSatisfactionSurveyFiltered(payload, success) {
        this.trackEvent(BUILDER_SATISFACTION_SURVEY_FILTERED, payload, success);
    }
    trackSelectedActionCheckbox(payload, success) {
        this.trackEvent(BUILDER_ACTION_SELECT_CHECKBOX, payload, success);
    }
    trackAllSelectedActionsCheckboxes(payload, success) {
        this.trackEvent(BUILDER_ACTION_SELECT_ALL_CHECKBOXES, payload, success);
    }
    trackSelectMoreoptions(payload, success) {
        this.trackEvent(BUILDER_ACTION_SELECT_MORE_OPTIONS, payload, success);
    }
    trackCopySelectedAction(payload, success) {
        this.trackEvent(BUILDER_MOREOPTIONS_MAIN, payload, success);
    }
    trackCopyAllActions(payload, success) {
        this.trackEvent(BUILDER_COPY_ALL_ACTIONS_SELECTED, payload, success);
    }
    trackPasteAction(payload, success) {
        this.trackEvent(BUILDER_PASTE_ACTION, payload, success);
    }
    trackPasteAllActionsSelected(payload, success) {
        this.trackEvent(BUILDER_PASTE_ALL_ACTIONS_SELECTED, payload, success);
    }
    trackDeleteAllActionsSelected(payload, success) {
        this.trackEvent(BUILDER_DELETE_ALL_ACTIONS_SELECTED, payload, success);
    }
    trackClickDocumentUrl(payload, success) {
        this.trackEvent(BUILDER_HELPCENTER_URL_CLICKED, payload, success);
    }
    trackEvent(event, payload, success, application) {
        this.SegmentService.createBotTrack(event, this.application || application, { ...payload, Status: this.eventStatus(success) });
    }
    trackApplicationEvent(event, application, payload, success) {
        this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application,
            payload: { ...payload, Status: this.eventStatus(success) },
        });
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
BuilderSegmentService.$inject = ['SegmentService'];
